import UnidadeList from '../layout/pages/UnidadesList.vue'
import RelatosList from '../layout/pages/RelatosList.vue'
import SetoresList from '../layout/pages/SetoresList.vue'
import NewRcdForm from '../layout/NewRcdForm.vue'
import { createStore } from 'vuex'
import { markRaw } from 'vue'
import NewUnidadeForm from '../layout/NewUnidadeForm.vue'
import NewSectorForm from '../layout/NewSectorForm.vue'
import UpdateSectorForm from '../layout/UpdateSectorForm.vue'
import UpdateUnidadeForm from '../layout/UpdateUnidadeForm.vue'
import Statistics from '../layout/pages/Statistics.vue'

export const dataRcd = createStore({
  state: () => {
    return {
      // rcd
      activeTab: 'relatos',
      componentActive: markRaw(UnidadeList),

      // combos
      unidades: [],
      setores: [],
      relatos: [],

      // forms
      unidadeForm: {
        unidade: undefined,
        cidade: undefined,
        estado: undefined
      },
      sectorForm: {
        participantes: undefined,
        name: undefined,
        email: undefined,
        integrantes: []
      },
      relatosForm: {

        // relatador
        name: undefined,
        unidade: undefined,
        empresa: undefined,
        setor: undefined,

        // dados do relatado
        relatoDescript: undefined,
        relatoOrigem: undefined,
        relatoClassi: undefined,
        relatoEmpresa: undefined,
        relatoUnidade: undefined,
        relatoSetor: undefined,
        relatoLocal: undefined,
        relatoDate: undefined,
        relatoCompe: undefined,

        // frequencia e gravidade
        frequency: undefined,
        gravity: undefined,
        classification: '',

        // mitigação
        relatoComp: undefined,
        relatoRisco: undefined,
        relatoAcao: undefined,
        relatoMiti: undefined
      },
      drawerModal: false,
      drawerModalContent: []
    }
  },
  getters: {
    getActiveTab: (state) => state.activeTab,
    getActiveComponent: (state) => markRaw(state.componentActive),
    getUnidades: (state) => state.unidades,
    getSetores: (state) => state.setores,
    getRelatos: (state) => state.relatos,
    getDrawerModal: (state) => state.drawerModal,
    getDrawerModalContent: (state) => state.drawerModalContent
  },
  mutations: {
    SET_ACTIVE_TAB (state, tabName) {
      state.activeTab = ''
      state.activeTab = tabName
    },
    SET_FORM_COMPONENT_ACTIVE (state) {
      state.componentActive = markRaw(NewRcdForm)
    },
    SET_LIST_COMPONENT_ACTIVE (state) {
      state.componentActive = markRaw(RelatosList)
    },
    SET_ACTIVE_COMPONENT_UNIDADE (state) {
      state.componentActive = markRaw(UnidadeList)
    },
    SET_ACTIVE_COMPONENT_STATISTICS (state) {
      state.componentActive = markRaw(Statistics)
    },
    SET_COMPONENT_ACTIVE_FORM_UNIDADE (state) {
      state.componentActive = markRaw(NewUnidadeForm)
    },
    SET_COMPONENT_ACTIVE_UPDATE_UNIDADE (state) {
      state.componentActive = markRaw(UpdateUnidadeForm)
    },
    SET_ACTIVE_COMPONENT_SECTORS (state) {
      state.componentActive = markRaw(SetoresList)
    },
    SET_COMPONENT_ACTIVE_FORM_SECTOR (state) {
      state.componentActive = markRaw(NewSectorForm)
    },
    SET_COMPONENT_ACTIVE_UPDATE_SECTOR (state) {
      state.componentActive = markRaw(UpdateSectorForm)
    },
    SET_UNIDADES (state, value) {
      state.unidades = []
      state.unidades = value
    },
    SET_SECTORS (state, value) {
      state.setores = []
      state.setores = value
    },
    SET_RELATOS (state, value) {
      state.relatos = []
      state.relatos = value
    },
    RESET_FORM (state) {
      state.unidadeForm.cidade = undefined
      state.unidadeForm.estado = undefined
      state.unidadeForm.unidade = undefined

      state.sectorForm.email = undefined
      state.sectorForm.integrantes = []
      state.sectorForm.name = undefined
      state.sectorForm.participantes = undefined
    },
    RESET_RELATO_FORM (state) {
      state.relatosForm.name = undefined
      state.relatosForm.unidade = undefined
      // state.relatosForm.empresa = undefined
      state.relatosForm.setor = undefined

      state.relatosForm.relatoDescript = undefined
      state.relatosForm.relatoOrigem = undefined
      // state.relatosForm.relatoClassi = undefined
      state.relatosForm.relatoEmpresa = undefined
      state.relatosForm.relatoUnidade = undefined
      state.relatosForm.relatoSetor = undefined
      state.relatosForm.relatoLocal = undefined
      state.relatosForm.relatoDate = undefined
      // state.relatosForm.relatoCompe = undefined

      state.relatosForm.frequency = undefined
      state.relatosForm.gravity = undefined
      state.relatosForm.classification = undefined

      // state.relatosForm.relatoComp = undefined
      // state.relatosForm.relatoRisco = undefined
      state.relatosForm.relatoAcao = undefined
      // state.relatosForm.relatoMiti = undefined
    },
    SET_DRAWER_ACTIVE (state, payload) {
      state.drawerModalContent = []
      state.drawerModalContent = payload
      state.drawerModal = true
    },
    SET_DRAWER_DESACTIVE (state) {
      state.drawerModal = false
      state.drawerModalContent = []
    }
  },
  actions: {
    setActiveTab ({ commit }, val) {
      commit('SET_ACTIVE_TAB', val)
    },
    setComponentActiveUnidade ({ commit }) {
      commit('SET_ACTIVE_COMPONENT_UNIDADE')
    },
    setComponentActiveStatistics ({ commit }) {
      commit('SET_ACTIVE_COMPONENT_STATISTICS')
    },
    setComponentActiveSectors ({ commit }) {
      commit('SET_ACTIVE_COMPONENT_SECTORS')
    },
    setListComponentActive ({ commit }) {
      commit('SET_LIST_COMPONENT_ACTIVE')
    },
    setComponentActiveFormUnidade ({ commit }) {
      commit('SET_COMPONENT_ACTIVE_FORM_UNIDADE')
    },
    setComponentActiveUpdateUnidade ({ commit }) {
      commit('SET_COMPONENT_ACTIVE_UPDATE_UNIDADE')
    },
    setComponentActiveFormSector ({ commit }) {
      commit('SET_COMPONENT_ACTIVE_FORM_SECTOR')
    },
    setComponentActiveUpdateSector ({ commit }) {
      commit('SET_COMPONENT_ACTIVE_UPDATE_SECTOR')
    },
    setUnidades ({ commit }, val) {
      commit('SET_UNIDADES', val)
    },
    listUnidades ({ commit }) {
      commit('LIST_ALL_UNIDADES')
    },
    setSectors ({ commit }, val) {
      commit('SET_SECTORS', val)
    },
    listSectors ({ commit }) {
      commit('LIST_ALL_SECTORS')
    },
    setRelatos ({ commit }, val) {
      commit('SET_RELATOS', val)
    },
    resetForms ({ commit }) {
      commit('RESET_FORM')
    },
    resetRelatoForm ({ commit }) {
      commit('RESET_RELATO_FORM')
    },
    setFormComponentActive ({ commit }) {
      commit('SET_FORM_COMPONENT_ACTIVE')
    },
    setModalActive ({ commit }, payload) {
      commit('SET_DRAWER_ACTIVE', payload)
    },
    setModalDesactive ({ commit }) {
      commit('SET_DRAWER_DESACTIVE')
    }
  }
})
